<div class="coupon-container">
  <div class="p-input-icon-left full-width search-input">
    <i class="pi pi-times" (click)="isShow=false; texttosearch.value = '';couponNum=null"></i>
    <input id="couponNum" [(ngModel)]="couponNum" type="text" pInputText pKeyFilter="num" #texttosearch
      placeholder="{{'COUPON.SEARCH_COUPON' | translate}}" (keyup)="isShow=false" maxlength="50">
  </div>
  <button class="command-button full full-width" [disabled]="!couponNum"
    (click)="searchCoupon()">{{'COUPON.DISPLAY_COUPON' | translate}}</button>
  <div *ngIf="isShow" class="couponDetailsDiv">
    <div class="row detail-row full-width">
      <span>{{'COUPON.STATUS' | translate}}</span>
      <div class="statusList row">
        <span class="statusList" [ngClass]="{'currentStatus':couponDetails.Status===status.value}"
          *ngFor="let status of statusList$|async">{{status.label}}
          <span *ngIf="status.value!==CouponStatus.expired">\</span>
        </span>
      </div>
    </div>
    <div class="row detail-row full-width">
      <span>{{'COUPON.PRAS_NAME' | translate}}</span>
      <span class="couponDetailsFields">{{couponDetails.CouponName}}</span>
    </div>
    <div class="row detail-row full-width">
      <span>{{'COUPON.PRAS_NUM' | translate}}</span>
      <span class="couponDetailsFields">{{couponDetails.CouponNum}}</span>
    </div>
    <div class="row detail-row full-width">
      <span>{{'COUPON.CUSTOMER_NAME' | translate}}</span>
      <span class="couponDetailsFields">{{couponDetails.CustomerName}}</span>
    </div>
    <div class="row detail-row full-width">
      <span>{{'COUPON.EXPIRATION' | translate}}</span>
      <span class="couponDetailsFields">{{couponDetails.ExpirationDate |date:'dd/MM/yyyy'}}</span>
    </div>
    <div class="row detail-row full-width">
      <span>{{'COUPON.CREATED' | translate}}</span>
      <span class="couponDetailsFields">{{couponDetails.Created |date:'dd/MM/yyyy'}}</span>
    </div>
    <div class="row detail-row full-width">
      <span *ngIf="couponDetails && couponDetails.DateUsed">{{'COUPON.DATE_USED'|translate}}</span>
      <span class="couponDetailsFields" *ngIf="couponDetails.DateUsed">{{couponDetails.DateUsed
        |date:'dd/MM/yyyy'}}</span>
    </div>
  </div>

  <button *ngIf="isShow" class="command-button full full-width" [disabled]="isRelized" (click)="implementCoupon()"
    blockButtonToSingleClick>{{'COUPON.IMPLEMENT_COUPON' | translate}}</button>

</div>